module.exports = __webpack_public_path__ + "static/media/img-4.62794447.png";